import { Button, Dialog, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { useTheme } from "../../../components/hooks/useTheme";
import React, { useEffect, useRef, useState } from "react";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import colorConfigs from "../../../configs/colorConfigs";
import { ReservationSelectWrapper } from "../../../components/common/ReservationSelectWrapper";
import baseURL from "../../../configs/api";
import axois from "../../../configs/axois";
import axios from "axios";
import { validateMin } from "../../../utils/validateMin";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import useConfirm from "../../../components/hooks/useConfirm";
import Cookies from "js-cookie";
import useAuth from "../../../components/hooks/useAuth";
import { getReservation } from "../../../services/reservation";
import { delete_fileUpload, getFileUploads, post_fileUpload, put_fileUpload } from "../../../services/appFileUpload";
import useDelete from "../../../components/hooks/useDelete";
import LocalSeeIcon from '@mui/icons-material/LocalSee';
import { handleCapture } from "../../../utils/covertTheBase64FormatIntoImage";
import Webcam from "react-webcam";
import { CustomImagePopup } from "../../../components/common/CustomImagePopup";
import useGeneral from "../../../components/hooks/useGeneral";
import useTenant from "../../../components/hooks/useTenant";

type EditDamageProps = {
    idNumber: any;
    openEditDamage: boolean;
    setOpenEditDamage: (value: boolean) => void;
    setRefreshDamageList: (value: boolean) => void;
    damageId: number;
}

export const EditDamage = ({ idNumber, openEditDamage, setOpenEditDamage, setRefreshDamageList, damageId }: EditDamageProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { dateFormat }: any = useGeneral();   
    const [accidentTypeOptions, setAccidentTypeOptions] = useState<any[]>([]);
    const [selectedAccidentType, setSelectedAccidentType] = useState<string>("");
    const [accidentDate, setAccidentDate] = useState<string>("");
    const [accidentTime, setAccidentTime] = useState<string>("");
    const [howDidHappend, setHowDidHappend] = useState<string>("");
    const [accidentLocation, setAccidentLocation] = useState<string>("");
    const [accidentCoordinates, setAccidentCoordinates] = useState<string>("");
    const [reservationId, setReservationId] = useState<number>(0);
    const [customerId, setCustomerId] = useState<number>(0);
    const [customerName, setCustomerName] = useState<string>("");
    const [driverName, setDriverName] = useState<string>("");
    const [driverLicenseNumber, setDriverLicenseNumber] = useState<string>("");
    const [insuranceCompany, setInsuranceCompany] = useState<string>("");
    const [insurancePolicyNumber, setInsurancePolicyNumber] = useState<string>('');
    const [insuranceClaimnumber, setInsuranceClaimnumber] = useState<string>('');
    const [weatherConditions, setWeatherConditions] = useState<string>('');
    const [roadConditions, setRoadConditions] = useState<string>('');
    const [damageDescription, setDamageDescription] = useState<string>('');
    const [damagedAreas, setDamagedAreas] = useState<string>('');
    const [injuriesReported, setInjuriesReported] = useState<boolean>(true);
    const [injuriesDetails, setInjuriesDetails] = useState<string>('');
    const [policeReportNumber, setPoliceReportNumber] = useState<string>('');
    const [witnessStatements, setWitnessStatements] = useState<string>('');
    const [diagramSketches, setDiagramSketches] = useState<string>('');
    const [reportStatus, setReportStatus] = useState<string>('');
    const [dateReportFiled, setDateReportFiled] = useState<string>('');
    const [timeReportFiled, setTimeReportFiled] = useState<string>('');
    const [filedBy, setFiledBy] = useState<string>('');
    const [notes, setNotes] = useState<string>('');
    const [vehicleCurrentLocation, setVehicleCurrentLocation] = useState<string>('');
    const [repairStatus, setRepairStatus] = useState<string>('');
    const [repairCompletionDate, setRepairCompletionDate] = useState<string>('');
    const [thirdPartyInvolvement, setThirdPartyInvolvement] = useState<boolean>(true);
    const [thirdPartyInformation, setThirdPartyInformation] = useState<string>('');
    const [towed, setTowed] = useState<boolean>(true);
    const [insuranceAmount, setInsuranceAmount] = useState<number>(0);
    const [repairEstimate, setRepairEstimate] = useState<number>(0);
    const [towedCharge, setTowedCharge] = useState<number>(0);
    const [bodyShopCharge, setBodyShopCharge] = useState<number>(0);
    const [mechanicalCharge, setMechanicalCharge] = useState<number>(0);
    const [partsCharge, setPartsCharge] = useState<number>(0);
    const [labourCharge, setLabourCharge] = useState<number>(0);
    const [totalExpense, setTotalExpense] = useState<number>(0);
    const [createdAt, setCreatedAt] = useState<string>("");
    const [createdBy, setCreatedBy] = useState<string>("");
    const [pageNo, setPage] = useState<number>(-1);
    const [hasNextPage, setHasNextPage] = useState<boolean>(true);
    const [isNextPageLoading, setNextPageLoading] = useState<boolean>(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<any>();
    const [pleaseWait, setPleaseWait] = useState<boolean>(false);
    const inputFileRef = useRef<HTMLInputElement>(null);
    const [filePath, setFilePath] = useState<any[]>([]);
    const [newFilePath, setNewFilePath] = useState<string[]>([]);
    const [fileIndex, setFileIndex] = useState<number>(-1);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [showWebcam, setShowWebcam] = useState<boolean>(false);
    const webRef = useRef(null);

    useEffect(() => {
        if (damageId > 0) {
            setPleaseWait(true);

            axios.get(`${baseURL}damageReport/${damageId}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((response) => {
                    setSelectedAccidentType(response?.data?.accidentType);
                    setAccidentDate(response?.data?.dateOfAccident?.split("T")[0]);
                    setAccidentTime(response?.data?.dateOfAccident?.split("T")[1]);
                    setHowDidHappend(response?.data?.howTheAccidentHappened);
                    setAccidentLocation(response?.data?.accidentLocation);
                    setAccidentCoordinates(response?.data?.accidentCoordinates);
                    setDriverName(response?.data?.driverName);
                    setDriverLicenseNumber(response?.data?.driverLicenseNumber);
                    setReservationId(response?.data?.reservationId);
                    setCustomerId(response?.data?.customerId);
                    setInsuranceCompany(response?.data?.insuranceCompany);
                    setInsurancePolicyNumber(response?.data?.insurancePolicyNumber);
                    setInsuranceClaimnumber(response?.data?.insuranceClaimnumber);
                    setWeatherConditions(response?.data?.weatherConditions);
                    setRoadConditions(response?.data?.roadConditions);
                    setDamageDescription(response?.data?.damageDescription);
                    setDamagedAreas(response?.data?.damagedAreas);
                    setInjuriesDetails(response?.data?.injuriesDetails);
                    setPoliceReportNumber(response?.data?.policeReportNumber);
                    setWitnessStatements(response?.data?.witnessStatements);
                    setDiagramSketches(response?.data?.diagramSketches);
                    setReportStatus(response?.data?.reportStatus);
                    setDateReportFiled(response?.data?.dateReportFiled?.split("T")[0]);
                    setTimeReportFiled(response?.data?.dateReportFiled?.split("T")[1])
                    setFiledBy(response?.data?.filedBy);
                    setNotes(response?.data?.notes);
                    setVehicleCurrentLocation(response?.data?.vehicleCurrentLocation);
                    setRepairStatus(response?.data?.repairStatus);
                    setRepairCompletionDate(response?.data?.repairCompletionDate);
                    setThirdPartyInformation(response?.data?.thirdPartyInformation);
                    setInjuriesReported(response?.data?.injuriesReported);
                    setThirdPartyInvolvement(response?.data?.thirdPartyInvolvement);
                    setTowed(response?.data?.towed);
                    setInsuranceAmount(response?.data?.insuranceAmount);
                    setRepairEstimate(response?.data?.repairEstimate);
                    setTowedCharge(response?.data?.towedCharge);
                    setBodyShopCharge(response?.data?.bodyShopCharge);
                    setMechanicalCharge(response?.data?.mechanicalCharge);
                    setPartsCharge(response?.data?.partsCharge);
                    setLabourCharge(response?.data?.labourCharge);
                    setTotalExpense(response?.data?.totalExpense);
                    getReservationForFirstTime(response?.data?.reservationId);
                    setCreatedAt(response?.data?.createdAt)
                    setCreatedBy(response?.data?.createdBy)
                    setPleaseWait(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWait(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [damageId]);

    useEffect(() => {
        if (damageId > 0) {
            getFileUploads("DamageReport", damageId.toString(), tenantId)
                .then((data) => {
                    setFilePath(() =>
                        data?.map((item: any) => {
                            return {
                                id: item.id,
                                fileName: item.fileName.startsWith("data:image/png;base64,")
                                    ? item.fileName
                                    : `${baseURL}commonFile/Get?name=` +
                                    item.fileName,
                            };
                        })
                    );

                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [damageId]);


    const getReservationForFirstTime = (id: number) => {
        if (id > 0) {
            getReservation(id.toString(), tenantId)
                .then((data) => {
                    setSelectedOption({
                        value: data?.id,
                        label: data?.bookingNumber
                    })
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }
    }

    useEffect(() => {
        axios.get(`${baseURL}damageType/GetDamageTypesWitActiveStatus/true`, {
            headers: {
                'X-Tenant-ID': tenantId,
            }
        })
            .then((response) => {
                const filterData = response?.data?.filter((item: any) => item?.isActive);

                setAccidentTypeOptions(
                    filterData?.map((item: any) => {
                        return {
                            value: item?.id,
                            label: item?.damageName
                        }
                    })
                );

                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (customerId && customerId > 0) {
            axois
                .get(`${baseURL}Customer/${customerId}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then((response) => {
                    setCustomerName(response.data?.firstName + " " + response.data?.lastName);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            setCustomerName("");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId])

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;
        setHasNextPage(true);
        setNextPageLoading(false);
        setPage(-1);
        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                setIsSearching(false);
                setOptions([]);
            }, 1000);
        } else {
            setOptions([]);
            setIsSearching(false);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    const loadNextPage = () => {
        if (searchValue === "") {
            loadWithOutSearchOptions(pageNo + 1);
        } else {
            loadWithSearchOptions(pageNo + 1);
        }
    };

    const loadWithOutSearchOptions = (page: number) => {
        try {
            const pagination = {
                page: page,
                size: 15,
            };
            setNextPageLoading(true);
            fetch(`${baseURL}reservation/GetReservationsByPage/${pagination.page},${pagination.size}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const dataOptions = data.reservationsDto.map((item: any) => {
                        return {
                            value: item.id,
                            label: item.bookingNumber,
                            customerId: item.customerId,
                        };
                    });

                    const itemsData = options.concat(dataOptions);
                    setOptions(itemsData);

                    setNextPageLoading(false);
                    setHasNextPage(itemsData.length < data.count);
                    setPage(page);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } catch (error) {
            handleTenantError(error);
        }
    };

    const loadWithSearchOptions = (page: number) => {
        try {
            const pagination = {
                page: page,
                size: 15,
            };
            setNextPageLoading(true);
            fetch(`${baseURL}reservation/GetReservationsPagingSearchWithBookingNumber?bookingNumber=${searchValue}&page=${pagination.page}&size=${pagination.size}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const dataOptions = data.reservationsDto.map((item: any) => {
                        return {
                            value: item.id,
                            label: item.bookingNumber,
                            customerId: item.customerId,
                        };
                    });

                    const itemsData = options.concat(dataOptions);
                    setOptions(itemsData);

                    setNextPageLoading(false);
                    setHasNextPage(itemsData.length < data.count);
                    setPage(page);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } catch (error) {
            handleTenantError(error);
        }
    };

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWait(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}commonFile/Get?name=` +
                            response.data,
                    };
                    setNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);

                    setFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWait(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            setPleaseWait(false);
        }
    };


    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

        setPleaseWait(true);
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    put_fileUpload({
                        id,
                        attributeName: "DamageReport",
                        attributeId: damageId,
                        fileName: response.data,
                        tabName: "DamageReport",
                        userId: auth?.id ?? 0,
                        createdDate: new Date()
                    }, auth?.id, tenantId)
                        .then((data) => {
                            setFilePath((prevPath: any[]) =>
                                prevPath.map(file =>
                                    file.id === id ? {
                                        ...file, fileName: `${baseURL}commonFile/Get?name=` +
                                            response.data,
                                    } : file
                                )
                            );
                            setPleaseWait(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                            setConfirmData({
                                title: 'Warning',
                                summary: errorMessage,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });
                            setConfirmPopup(true);
                            setPleaseWait(false);
                            handleTenantError(error);
                        })
                        handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWait(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWait(false);
        }


    }

    const handelSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWait(true);

        axios
            .put(
                `${baseURL}damageReport?userId=${auth?.id}`,
                JSON.stringify({
                    id: damageId,                   
                    vehicleId: idNumber?.state,
                    dateOfAccident: new Date(accidentDate + 'T' + accidentTime)?.toLocaleString(),
                    accidentLocation,
                    accidentCoordinates,
                    reservationId,
                    customerId,
                    driverName,
                    driverLicenseNumber,
                    insuranceCompany,
                    insurancePolicyNumber,
                    insuranceClaimnumber,
                    insuranceAmount,
                    accidentType: selectedAccidentType,
                    weatherConditions,
                    roadConditions,
                    damageDescription,
                    damagedAreas,
                    injuriesReported,
                    injuriesDetails,
                    policeReportNumber,
                    witnessStatements,
                    diagramSketches,
                    reportStatus,
                    dateReportFiled: dateReportFiled && timeReportFiled ? new Date(dateReportFiled + 'T' + timeReportFiled)?.toLocaleString() : null,
                    filedBy,
                    notes,
                    vehicleCurrentLocation,
                    repairEstimate,
                    repairStatus,
                    repairCompletionDate,
                    thirdPartyInvolvement,
                    thirdPartyInformation,
                    howTheAccidentHappened: howDidHappend,
                    towed,
                    towedCharge,
                    bodyShopCharge,
                    mechanicalCharge,
                    partsCharge,
                    labourCharge,
                    totalExpense,
                    createdAt,
                    createdBy,
                    updatedAt: new Date().toLocaleString(),
                    updatedBy: auth?.givenname,
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                    withCredentials: true,
                }
            )
            .then(() => {
                saveImages()
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWait(false);
                handleTenantError(error);
            });
    }

    const saveImages = () => {
        if (newFilePath?.length !== 0) {
            newFilePath.forEach(async (item: string, index: number) => {
                await post_fileUpload({
                    attributeName: "DamageReport",
                    attributeId: damageId,
                    fileName: item?.replace(
                        `${baseURL}commonFile/Get?name=`,
                        ""
                    ),
                    tabName: "DamageReport",
                    userId: auth?.id ?? 0,
                    createdDate: new Date(),
                }, auth?.id, tenantId)
                    .then(() => {
                        if (newFilePath?.length - 1 === index) {
                            setPleaseWait(false);
                            setOpenEditDamage(false);
                            setRefreshDamageList(true);
                        }
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    });
            });
        } else {
            setPleaseWait(false);
            setOpenEditDamage(false);
            setRefreshDamageList(true);
        }

    }

    const deleteDamage = () => {
        setDeleteData({
            tilte: 'Delete',
            summary: "Are you sure you want to delete this damage report?",
            confirmBtn: 'Yes',
            isDelete: (callback: any) => {
                setPleaseWait(true);

                fetch(`${baseURL}damageReport?id=${damageId}&userId=${auth?.id}`, {
                    method: 'DELETE',
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then(() => {
                        setPleaseWait(false);
                        setOpenEditDamage(false);
                        setRefreshDamageList(true);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });
        setDeletePopup(true);
    }

    return (
        <>
            <Dialog
                open={openEditDamage}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '550px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>

                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Damage</h2>

                                    <span className={`material-symbols-outlined text-[25px] font-light cursor-pointer ${themeStyles.main.textHeadingColor}`} onClick={() => setOpenEditDamage(false)}>close</span>

                                </div>
                                <form onSubmit={handelSubmit}>
                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accident Date</label>
                                                <CustomFormatDatePicker
                                                    value={accidentDate}
                                                    onChange={(value) => {
                                                        setAccidentDate(value)
                                                    }}
                                                    dateFormat={dateFormat}
                                                    required={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accident Time</label>
                                                <input
                                                    type="time"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={accidentTime}
                                                    onChange={(e) => {
                                                        setAccidentTime(e.target.value)
                                                    }}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accident Type</label>
                                        <select
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={selectedAccidentType}
                                            onChange={(e) => setSelectedAccidentType(e.target.value)}
                                            required
                                        >
                                            {
                                                accidentTypeOptions?.map((item: any, index: number) => {
                                                    return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item.value}>{item.label}</option>;
                                                })
                                            }
                                        </select>
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>How Did it Happend</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={howDidHappend}
                                            onChange={(e) => setHowDidHappend(e.target.value)}
                                        />
                                    </div>
                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accident Location</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={accidentLocation}
                                            onChange={(e) => {
                                                setAccidentLocation(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accident Coordinates</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={accidentCoordinates}
                                            onChange={(e) => {
                                                setAccidentCoordinates(e.target.value)
                                            }}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <div className="w-full flex flex-row items-center gap-[5px] flex-wrap">
                                            {
                                                filePath?.map((item: any, outerIndex: number) => (
                                                    <React.Fragment key={outerIndex}>
                                                        <img
                                                            src={item?.fileName}
                                                            width={40}
                                                            height={40}
                                                            alt="damage"
                                                            onClick={() => {
                                                                setFileIndex(outerIndex);
                                                                setImagePopup(true);
                                                            }}
                                                        />
                                                        <RemoveCircleIcon
                                                            className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                            onClick={() => {

                                                                setConfirmData({
                                                                    title: 'Delete image',
                                                                    summary: 'Are you sure you want to delete this image?',
                                                                    confirmBtn: 'Yes',
                                                                    isConfirm: (callback: any) => {
                                                                        let newFileSet: string[] = filePath.filter(
                                                                            (_, index: number) => index !== outerIndex
                                                                        );
                                                                        if (filePath[outerIndex].id === 0) {
                                                                            setFilePath(() => newFileSet);
                                                                        } else {
                                                                            delete_fileUpload(filePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                .then(() => {
                                                                                    setFilePath(() => newFileSet);
                                                                                    handleTenantError(null);
                                                                                })
                                                                                .catch((error) => {
                                                                                    handleTenantError(error);
                                                                                });
                                                                        }
                                                                        callback();
                                                                    }
                                                                });

                                                                setConfirmPopup(true);
                                                            }}

                                                        />
                                                    </React.Fragment>
                                                ))
                                            }
                                        </div>
                                        <div>
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={inputFileRef}
                                                onChangeCapture={onFileChangeCapture}
                                                style={{ display: "none" }}
                                            />
                                            <div className="flex flex-row gap-2 mt-2">
                                                <p
                                                    className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                    onClick={() => {

                                                        if (inputFileRef.current !== null) {
                                                            inputFileRef.current.value = "";

                                                        }
                                                        inputFileRef.current?.click();
                                                    }}
                                                >
                                                    <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                    Add Image
                                                </p>
                                                <p
                                                    className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                    onClick={() => {

                                                        setShowWebcam(true)
                                                    }}
                                                >
                                                    <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                </p>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Reservation</label>
                                                <ReservationSelectWrapper
                                                    hasNextPage={hasNextPage}
                                                    isNextPageLoading={isNextPageLoading}
                                                    setSearchValue={setSearchValue}
                                                    options={options}
                                                    setPage={setPage}
                                                    loadNextPage={loadNextPage}
                                                    selectedOption={selectedOption}
                                                    isSearching={isSearching}
                                                    setIsSearching={setIsSearching}
                                                    onChange={(selectedOption: any) => {
                                                        setReservationId(selectedOption?.value)
                                                        setCustomerId(selectedOption?.customerId)
                                                        setSelectedOption(selectedOption);
                                                    }}
                                                    baseWidth="100%"
                                                    height={150}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Driver Name</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={driverName}
                                                    onChange={(e) => {
                                                        setDriverName(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Insurance Company</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={insuranceCompany}
                                                    onChange={(e) => {
                                                        setInsuranceCompany(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Insurance Claim Number</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={insuranceClaimnumber}
                                                    onChange={(e) => {
                                                        setInsuranceClaimnumber(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Weather Conditions</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={weatherConditions}
                                                    onChange={(e) => {
                                                        setWeatherConditions(e.target.value)
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Customer Name</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={customerName}
                                                    onChange={(e) => {
                                                        setCustomerName(e.target.value)
                                                    }}
                                                    readOnly
                                                />
                                            </div>
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Driver's Lincense Number</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={driverLicenseNumber}
                                                    onChange={(e) => {
                                                        setDriverLicenseNumber(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Insurance Policy Number</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={insurancePolicyNumber}
                                                    onChange={(e) => {
                                                        setInsurancePolicyNumber(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Insurance Amount</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={insuranceAmount}
                                                    onChange={(e) => {
                                                        setInsuranceAmount(validateMin(e.target.value, 0))
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Road Conditions</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={roadConditions}
                                                    onChange={(e) => {
                                                        setRoadConditions(e.target.value)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Damage Description</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={damageDescription}
                                            onChange={(e) => setDamageDescription(e.target.value)}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Damage Areas</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={damagedAreas}
                                            onChange={(e) => setDamagedAreas(e.target.value)}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Injuries Reported</label>
                                        <RadioGroup
                                            row
                                            value={injuriesReported ? "Yes" : "No"}
                                            onChange={(e) => setInjuriesReported(e.target.value === "Yes" ? true : false)}
                                        >
                                            <FormControlLabel
                                                value="Yes"
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: "gray",
                                                            "&.Mui-checked": {
                                                                color: "#167AC3",
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 14,
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="Yes"
                                                sx={{
                                                    color: themeStyles.form.labelTextColor
                                                }}
                                            />

                                            <FormControlLabel
                                                value="No"
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: "gray",
                                                            "&.Mui-checked": {
                                                                color: "#167AC3",
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 14,
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="No"
                                                sx={{
                                                    color: themeStyles.form.labelTextColor
                                                }}
                                            />
                                        </RadioGroup>
                                    </div>

                                    {
                                        injuriesReported && (
                                            <div className="w-full mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Injury Details</label>
                                                <textarea
                                                    className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    rows={6}
                                                    value={injuriesDetails}
                                                    onChange={(e) => setInjuriesDetails(e.target.value)}
                                                />
                                            </div>
                                        )
                                    }

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Police Report Number</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={policeReportNumber}
                                            onChange={(e) => {
                                                setPoliceReportNumber(e.target.value)
                                            }}

                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Witness Statements</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={witnessStatements}
                                            onChange={(e) => setWitnessStatements(e.target.value)}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Diagram Sketches</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={diagramSketches}
                                            onChange={(e) => {
                                                setDiagramSketches(e.target.value)
                                            }}

                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Report Status</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={reportStatus}
                                            onChange={(e) => {
                                                setReportStatus(e.target.value)
                                            }}

                                        />
                                    </div>

                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Report Filed Date</label>
                                                <CustomFormatDatePicker
                                                    value={dateReportFiled}
                                                    onChange={(value) => {
                                                        setDateReportFiled(value)

                                                    }}
                                                    dateFormat={dateFormat}
                                                    required={false}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Report Filed Time</label>
                                                <input
                                                    type="time"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={timeReportFiled}
                                                    onChange={(e) => {
                                                        setTimeReportFiled(e.target.value)
                                                    }}

                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Filed By</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={filedBy}
                                            onChange={(e) => {
                                                setFiledBy(e.target.value)
                                            }}

                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Notes</label>
                                        <textarea
                                            className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            rows={6}
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                        />
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Current Location</label>
                                        <input
                                            type="text"
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={vehicleCurrentLocation}
                                            onChange={(e) => {
                                                setVehicleCurrentLocation(e.target.value)
                                            }}

                                        />
                                    </div>

                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repair Estimate</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={repairEstimate}
                                                    onChange={(e) => {
                                                        setRepairEstimate(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repair Completion Date</label>


                                                <CustomFormatDatePicker
                                                    value={repairCompletionDate}
                                                    onChange={(value) => {
                                                        setRepairCompletionDate(value)

                                                    }}
                                                    dateFormat={dateFormat}
                                                    required={false}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repair Status</label>
                                                <input
                                                    type="text"
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={repairStatus}
                                                    onChange={(e) => {
                                                        setRepairStatus(e.target.value)
                                                    }}

                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Third Party Involment</label>
                                                <RadioGroup
                                                    row
                                                    value={thirdPartyInvolvement ? "Yes" : "No"}
                                                    onChange={(e) => setThirdPartyInvolvement(e.target.value === "Yes" ? true : false)}
                                                >
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "#167AC3",
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: 14,
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="Yes"
                                                        sx={{
                                                            color: themeStyles.form.labelTextColor
                                                        }}
                                                    />

                                                    <FormControlLabel
                                                        value="No"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "#167AC3",
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: 14,
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="No"
                                                        sx={{
                                                            color: themeStyles.form.labelTextColor
                                                        }}
                                                    />
                                                </RadioGroup>
                                            </div>


                                        </div>
                                    </div>
                                    {
                                        thirdPartyInvolvement && (
                                            <div className="w-full mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Third Party Information</label>
                                                <textarea
                                                    className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    rows={6}
                                                    value={thirdPartyInformation}
                                                    onChange={(e) => setThirdPartyInformation(e.target.value)}
                                                />
                                            </div>
                                        )
                                    }

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Towed</label>
                                        <RadioGroup
                                            row
                                            value={towed ? "Yes" : "No"}
                                            onChange={(e) => setTowed(e.target.value === "Yes" ? true : false)}
                                        >
                                            <FormControlLabel
                                                value="Yes"
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: "gray",
                                                            "&.Mui-checked": {
                                                                color: "#167AC3",
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 14,
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="Yes"
                                                sx={{
                                                    color: themeStyles.form.labelTextColor
                                                }}
                                            />

                                            <FormControlLabel
                                                value="No"
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: "gray",
                                                            "&.Mui-checked": {
                                                                color: "#167AC3",
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 14,
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="No"
                                                sx={{
                                                    color: themeStyles.form.labelTextColor
                                                }}
                                            />
                                        </RadioGroup>
                                    </div>
                                    {
                                        towed && (
                                            <div className="w-full mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Towed Charge</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={towedCharge}
                                                    onChange={(e) => {
                                                        setTowedCharge(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>
                                        )
                                    }


                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="space-y-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Body Shop Charge</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={bodyShopCharge}
                                                    onChange={(e) => {
                                                        setBodyShopCharge(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Parts Charge</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={partsCharge}
                                                    onChange={(e) => {
                                                        setPartsCharge(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mechanical Charge</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={mechanicalCharge}
                                                    onChange={(e) => {
                                                        setMechanicalCharge(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>


                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Labour Charge</label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    min={0}
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={labourCharge}
                                                    onChange={(e) => {
                                                        setLabourCharge(validateMin(e.target.value, 0))
                                                    }}

                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="w-full mt-4">
                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Total Expense</label>
                                        <input
                                            type="number"
                                            step={0.01}
                                            min={0}
                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                            value={totalExpense}
                                            onChange={(e) => {
                                                setTotalExpense(validateMin(e.target.value, 0))
                                            }}

                                        />
                                    </div>

                                    <div className="mt-4 w-full flex gap-4">
                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.main.bg
                                            }}
                                            type="submit"
                                        >
                                            Save
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => setOpenEditDamage(false)}
                                        >
                                            Cancel
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.delete.bg
                                            }}
                                            onClick={() => deleteDamage()}
                                        >
                                            Delete
                                        </Button>




                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </Dialog>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={filePath}
                fileIndex={fileIndex}
                setFileIndex={setFileIndex}
                imageBaseUrlPath="commonFile"
                updateFile={updateFile}
            />

            <Dialog
                open={showWebcam}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <Webcam
                                            width={500}
                                            height={320}
                                            ref={webRef}
                                            screenshotFormat="image/png"
                                            audio={false}
                                        />

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => {

                                                    setShowWebcam(false)
                                                }}>
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                onClick={() => {
                                                    if (webRef.current !== null) {
                                                        //@ts-ignore
                                                        const imageSrc = webRef.current.getScreenshot();

                                                        handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                                                            if (imageFilePath) {
                                                                setNewFilePath((prevFileString: string[]) => [
                                                                    ...prevFileString,
                                                                    `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                ]);

                                                                const newFile: any = {
                                                                    id: 0,
                                                                    fileName: `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                };
                                                                setFilePath((prevFileString: any[]) => [
                                                                    ...prevFileString,
                                                                    newFile,
                                                                ]);
                                                            }
                                                        })
                                                        setShowWebcam(false);
                                                    }
                                                }}
                                            >
                                                Capture an Image
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
        </>
    )
}